import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumVehicleProfile implements BaseEnumType {
  private static allValues: EnumVehicleProfile[] = []; // make sure this is top-most
  
  public static none = new EnumVehicleProfile(0, "None", "enum_vehicle_profile_none");
  public static van = new EnumVehicleProfile(1, "Van", "enum_vehicle_profile_van");
  public static hgv = new EnumVehicleProfile(2, "Hgv", "enum_vehicle_profile_hgv");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumVehicleProfile.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumVehicleProfile.none; }
  public isVan() { return this === EnumVehicleProfile.van; }
  public isHgv() { return this === EnumVehicleProfile.hgv; }

  public static getValues(): readonly EnumVehicleProfile[] {
    return EnumVehicleProfile.allValues;
  }

  public static getValuesExcept0(): readonly EnumVehicleProfile[] {
    return EnumVehicleProfile.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumVehicleProfile {
    const found = EnumVehicleProfile.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumVehicleProfile - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumVehicleProfile): EnumVehicleProfile {
    const found = name ? EnumVehicleProfile.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumVehicleProfile - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumVehicleProfile>): boolean {
    return this.key === other?.key;
  }
}